import { API } from '../api.js';
import styles from './Avatar.module.css';

export default function Avatar({ user, size = 40 }) {
  const name = user?.name || user?.displayName || user?.display_name || '';
  const avatarValue = user?.avatar || user?.avatarEmoji || user?.avatar_url || user?.avatarUrl;
  const initial = name ? name.charAt(0).toUpperCase() : '?';

  // Check if avatar is a URL/image path (starts with / or http or contains /uploads/)
  const isImage = typeof avatarValue === 'string' && (avatarValue.startsWith('/') || avatarValue.startsWith('http') || avatarValue.includes('uploads'));

  return (
    <div
      className={styles.avatar}
      style={{ 
        width: size, 
        height: size, 
        fontSize: size * 0.45,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--accent-soft)',
        borderRadius: '50%',
        border: '1px solid var(--border)',
      }}
    >
      {isImage ? (
        <img 
          src={avatarValue.startsWith('http') ? avatarValue : `${API}${avatarValue}`} 
          alt={user?.name || 'avatar'} 
          style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
        />
      ) : (
        avatarValue || initial
      )}
    </div>
  );
}
